import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

/**
 * Le toast d'erreur du portail, partagé par `ApiErrorInterceptor` et la page de login.
 *
 * <strong>Pourquoi la page de login ne s'en remet pas à l'intercepteur.</strong> Il ne traite que les
 * URL absolues des `apiBasePaths`. L'ouverture de session part sur une URL **relative**, servie par
 * CloudFront depuis UAA (`AuthorizationSessionService` dit pourquoi) : elle lui échappe. Tant que le
 * login historique passait en premier, c'est lui qui affichait « L'email ou le mot de passe est
 * incorrect » ; depuis qu'il est retiré (O2.12), la page doit le faire elle-même. Faire passer la
 * session par l'intercepteur ne serait pas mieux : son contrôle `isTokenExpired()` avalerait la
 * requête dès qu'un jeton périmé traîne dans le stockage.
 */
@Injectable({ providedIn: 'root' })
export class ApiErrorToastService {
  constructor(
    private translate: TranslateService,
    private toasterService: ToastrService
  ) {}

  show(translationKey: string): void {
    this.translate.get(translationKey).subscribe((translation) => {
      if (translation) {
        this.toasterService.error(translation, null, {
          positionClass: 'toast-bottom-center',
          timeOut: 5000,
        });
      }
    });
  }
}
